<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">{{ property_data.name }}</h1>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card">
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Name:</span><span>{{ property_data.name }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full info-cards__row-item--flex-start">
              <span>Lease:</span>
              <span v-if="property_data.min_agreement_date">{{ dateFormat(property_data.min_agreement_date) }} - {{ dateFormat(property_data.max_agreement_date) }}</span>
              <span v-else>-</span>
            </div>
          </div>
        </div>
      </div>
      <app-tabs :tabs="tabs" />
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </template>
  </div>
</template>

<script>

import { getAdministrativeProperty } from '@/http'
import AppTabs from '@/components/AppTabs.vue'
import { format, parseISO } from 'date-fns'

export default {
  name: 'AdministrativePropertiesDetailLayout',
  components: { AppTabs },
  data() {
    return {
      page_loaded: false,
      property_data: {},
      tabs: [
        { name: 'administrative-properties-detail-lease-agreements', label: 'Lease agreements' },
        { name: 'administrative-properties-detail-insurances', label: 'Insurances' },
      ],
    }
  },
  created() {
    getAdministrativeProperty(this.$route.params.id)
      .then(res => {
        this.property_data = res.data
        this.page_loaded = true
      })
  },
  methods: {
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : ''
    },
  }
}
</script>
